import { Body } from "../../Common/Typography";
import { MapToolLabelWrapper } from "./__styles__/MapTools";

export const MapToolLabel = ({
  label,
  ...wrapperProps
}: {
  label: string;
  hide?: boolean;
  permanent?: boolean;
  onClick?: (args: any) => void;
}) => {
  return (
    <MapToolLabelWrapper {...wrapperProps}>
      <Body type="regular" size="large" color="contentPrimaryInverted">
        {label}
      </Body>
    </MapToolLabelWrapper>
  );
};
